/* src/pages/AboutPage.js */
import React, { useContext, useState, useEffect } from "react";
import "./AboutPage.css";
// import ComplianceBanner from "../components/ComplianceBanner"; // non più usato
import { MODE, showOCFData, getRegistration } from "../config/compliance";
import Seo from "../components/Seo";
import { LangContext } from "../lang/LangProvider";
import MailingListModal from "../components/MailingListModal";
import ContactFormModal from "../components/ContactFormModal";

const AboutPage = () => {
  const { lang } = useContext(LangContext);
  const [isMailingListModalOpen, setIsMailingListModalOpen] = useState(false);
  const [isContactFormModalOpen, setIsContactFormModalOpen] = useState(false);

  // Apri il modal di mailing list se l'URL ha #newsletter
  useEffect(() => {
    if (window.location.hash === "#newsletter") {
      setIsMailingListModalOpen(true);
    }
  }, []);


  const seoTitle = lang === "en" ? "About us" : "Chi siamo";
  const seoDesc =
    lang === "en"
      ? "AlphaFrame Analytics blends quantitative finance and AI in informational and educational content and simulation tools. The investment advice service has not yet commenced."
      : "AlphaFrame Analytics integra finanza quantitativa e AI in contenuti informativi, educativi e strumenti di simulazione. Il servizio di consulenza in materia di investimenti non è attualmente avviato.";

  // mailSubject e mailBody rimossi: sostituiti dal form GDPR strutturato

  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDesc}
        path={`/${lang}/about`}
        image="/og/cover-about.png"
      />

      <div className="aboutpage-bg">
        <div className="about-container">
          {/* <ComplianceBanner />  // Se vuoi mostrarlo anche qui, decommenta */}

          <section className="about-hero">
            <h1>{lang === "en" ? "About Us" : "Chi Siamo"}</h1>
            <p>
              <strong>AlphaFrame Analytics</strong>{" "}
              {lang === "en"
                ? "combines quantitative finance and AI with an ethical and independent approach."
                : "unisce finanza quantitativa e AI con un approccio etico e indipendente."}
            </p>
          </section>

          <section className="about-section">
            <h2>{lang === "en" ? "Expertise" : "Competenze"}</h2>
            <ul>
              <li>
                {lang === "en"
                  ? "Data Science: Machine Learning & Deep Learning applied to markets"
                  : "Data Science: Machine Learning & Deep Learning applicati ai mercati"}
              </li>
              <li>
                {lang === "en"
                  ? "Quantitative asset allocation & risk management"
                  : "Asset allocation quantitativa & risk management"}
              </li>
              <li>
                {lang === "en"
                  ? "Research Fellowship, University of Padua (2016, 2018, 2024)"
                  : "Research Fellowship, University of Padova (2016, 2018, 2024)"}
              </li>
            </ul>
          </section>

          <section className="about-section">
            <h2>{lang === "en" ? "Certifications & Licenses" : "Certificazioni & Abilitazioni"}</h2>
            <ul>
              {showOCFData && (
                <li>
                  {lang === "en" ? "OCF Exam – 92/100" : "Esame OCF – 92/100"} <br />
                  {MODE === "PRE" ? (
                    <em>
                      {lang === "en"
                        ? "(Registration in progress: advisory activity will start after the registration is published)"
                        : "(Iscrizione all’albo in corso: l’attività consulenziale inizierà dopo la pubblicazione dell’iscrizione)"}
                    </em>
                  ) : (
                    <em>{getRegistration(lang)}</em>
                  )}
                </li>
              )}
              <li>Deep Learning Specialization – Coursera</li>
              <li>PMP<sup>®</sup> – Project Management Professional</li>
            </ul>
          </section>

          <section className="about-section about-contacts" id="newsletter">
            <button
              className="about-section-heading-btn"
              onClick={() => setIsContactFormModalOpen(true)}
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
            >
              <h2 style={{ margin: 0, textAlign: "left" }}>
                {lang === "en" ? "Contact & Updates" : "Contatti & Aggiornamenti"}
              </h2>
            </button>
            <p>
              {lang === "en"
                ? "Questions, collaborations or information requests? Write to us. These contacts are for general information only: they cannot be used to confer investment advisory engagements."
                : "Domande, collaborazioni o richieste di informazioni? Scrivimi. I contatti sono per informazioni generali: non consentono il conferimento di incarichi di consulenza."}
            </p>

            <div style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
              <button
                className="hero-btn primary"
                onClick={() => setIsContactFormModalOpen(true)}
              >
                {lang === "en" ? "Send us a message" : "Invia un messaggio"}
              </button>
              <button
                className="hero-btn secondary"
                onClick={() => setIsMailingListModalOpen(true)}
              >
                {lang === "en" ? "Subscribe to updates" : "Iscriviti agli aggiornamenti"}
              </button>
            </div>

            <div className="about-contacts-links">
              <a href="https://www.youtube.com/channel/UCRr6dSJE95B8z-czPW-aq_Q" target="_blank" rel="noopener noreferrer">
                YouTube — AlphaFrameAnalytics
              </a>
              <a href="mailto:alphaframeanalytics.it@gmail.com">
                alphaframeanalytics.it@gmail.com
              </a>
            </div>
          </section>

          <section className="about-disclaimer">
            <p>
              <b>{lang === "en" ? "Professional disclaimer" : "Disclaimer professionale"}</b>
              <br />
              {MODE === "EDU" ? (
                <>
                  {lang === "en"
                    ? <>This website is for <b>educational and informational purposes only</b>. No personalized financial advice, no investment solicitation.</>
                    : <>Questo sito ha finalità esclusivamente <b>educative e informative</b>. Nessuna consulenza personalizzata né invito all’investimento.</>}
                </>
              ) : MODE === "PRE" ? (
                <>
                  {lang === "en"
                    ? <>The website serves educational/informational purposes only. <b>No personalized recommendations</b> or investment solicitations under TUF (Leg. Decree 58/1998). Advisory services will be provided <b>only after OCF registration</b>.</>
                    : <>Il sito ha finalità informative/educative. <b>Nessuna raccomandazione personalizzata</b> o invito all’investimento ai sensi del TUF (D.Lgs. 58/1998). La consulenza sarà prestata <b>solo dopo l’iscrizione OCF</b>.</>}
                </>
              ) : (
                <>
                  {lang === "en"
                    ? <>The website serves informational and educational purposes: <b>no personalised recommendations</b> and no investment solicitation. Registration in the Italian register does not imply approval of this website's content by the OCF or CONSOB.</>
                    : <>Il sito ha finalità informative ed educative: <b>nessuna raccomandazione personalizzata</b> né invito all’investimento. L’iscrizione all’Albo non comporta approvazione dei contenuti del sito da parte dell’OCF o della CONSOB.</>}
                </>
              )}
            </p>
          </section>
        </div>
      </div>

      <MailingListModal
        isOpen={isMailingListModalOpen}
        onClose={() => setIsMailingListModalOpen(false)}
      />
      <ContactFormModal
        isOpen={isContactFormModalOpen}
        onClose={() => setIsContactFormModalOpen(false)}
      />
    </>
  );
};

export default AboutPage;
